import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck } from '@fortawesome/free-solid-svg-icons';


import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';
import { URL_EMPLOYEE } from '../../constans/servidor';


import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import TableComponent from '../Desenganche/Filtrado';
import { set } from 'immutable';
let dato = []
let cambiar = false
let estados=false
let  nits

function Formulario(props) {
	const { modal} = props;
	const [myVariable, setMyVariable] = useState('Valor inicial');

	const [errorMessageA, setErrorMessageA] = useState('');
	const [errorMessageB, setErrorMessageB] = useState('');
	const [placa, setPlaca] = useState();
	const [objeto, setObjeto] = useState()
	const [loading, setLoading] = useState(true);
	const [estado, setEstado] = useState(false)
	const [nitId,setnetId]=useState()
	// const [TerminalesB, setTerminalesB] = useState();

	const [datosCorrectosA, setdatosCorrectosA] = useState(false);
	const [datosCorrectosB, setdatosCorrectosB] = useState(false);
	const {
		control,
		watch,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();
	
	const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
	const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
	const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
	const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
	const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
	const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
	const regExpBicis = /^[Bb]ici[0-9]{3}$/;
	const regExpBici = /^[Bb]ici[0-9]{2}$/;


	const verificarPlaca = (placa) => {
		console.log(placa);
		if (
			regExpCarro.test(placa) ||
			regExpCarroR.test(placa) ||
			regExpCarroA.test(placa) ||
			regExpCarroV.test(placa) ||
			regExpMoto.test(placa) ||
			regExpMotoAntigua.test(placa) ||
			regExpBicis.test(placa) ||
			regExpBici.test(placa)
		) {
			console.log('entre');
			setPlaca(true);
		} else {
			setPlaca(false);
		}
	};
	const onSubmit = async (data) => {
		// creas un array vacío
		console.log('Aquiii');
		console.log(nits);
		var fechaA = new Date(data.fechaActivacion);
		var fechaE = new Date(data.fechaExpiracion);
		var anio = fechaA.getFullYear();
		var mes = fechaA.getMonth() + 1;
		var dia = fechaA.getDate();
		var anioE = fechaE.getFullYear();
		var mesE = fechaE.getMonth() + 1;
		var diaE = fechaE.getDate();
		var fechaFormateadaA = anio + "-" + (mes < 10 ? "0" + mes : mes) + "-" + (dia < 10 ? "0" + dia : dia);
		var fechaFormateadaE = anioE + "-" + (mesE < 10 ? "0" + mesE : mesE) + "-" + (diaE < 10 ? "0" + diaE : diaE);
		let miObjeto = { // creas un objeto
			document: nits.companyNit,
			name: data.nombre,
			plate: (data.placa).toUpperCase(),
			idMonthlyContract: nits.idMonthlyContract,
			activationDate: fechaFormateadaA,
			expirationDate: fechaFormateadaE,
			qr: data.qr,
			barcode: data.barcode,
			transmitted: 1,
		};
		console.log(miObjeto);
		if (
			data.nombre != undefined &&
			data.placa != undefined &&
			fechaFormateadaA != undefined &&
			fechaFormateadaE != undefined &&
			data.qr != undefined &&
			data.barcode != undefined
		) {
			console.log('aqui en datos');
			cambiar = true
			setEstado(true)
		} else {
			console.log('en los otros');
			setEstado(false)

		}
		dato.push(miObjeto);
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Row className={estado ? "azul mbottom-20" : "rojo mbottom-20"} >
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputmayuscula">
						<Form.Label className='texto-label'>Nombre </Form.Label>
						<Controller
							name="nombre"
							control={control}
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="text"
									onBlur={onBlur}
									onChange={(value) => onChange(value)}
									value={value}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputmayuscula">
						<Form.Label className='texto-label'>Placa</Form.Label>
						<Controller
							name="placa"
							control={control}
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="text"
									onBlur={onBlur}
									onChange={(value) => onChange(value)}
									value={value}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputmayuscula">
						<Form.Label className='texto-label'>QR</Form.Label>
						<Controller
							name="qr"
							control={control}
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="text"
									onBlur={onBlur}
									onChange={(value) => onChange(value)}
									value={value}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputmayuscula">
						<Form.Label className='texto-label'>Barcode</Form.Label>
						<Controller
							name="barcode"
							control={control}
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="texto"
									onBlur={onBlur}
									onChange={(value) => onChange(value)}
									value={value}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={4} md={4} lg={4} xl={4}>
					<Form.Group controlId="formBasicEmail">
						<Form.Label className='texto-label'>Fecha de Activacion </Form.Label>
						<Controller
							name="fechaActivacion"
							control={control}
							rules={{ required: true }}
							defaultValue={new Date()}
							render={({ field: { onChange, onBlur, value } }) => (
								<DatePicker
									className="form-control"
									selected={value}
									dateFormat="yyyy-MM-dd"
									onChange={(date) => onChange(date)}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={4} md={4} lg={4} xl={4}>
					<Form.Group controlId="formBasicEmail">
						<Form.Label className='texto-label'>Fecha de Expiración </Form.Label>
						<Controller
							name="fechaExpiracion"
							control={control}
							rules={{ required: true }}
							defaultValue={new Date()}
							render={({ field: { onChange, onBlur, value } }) => (
								<DatePicker
									className="form-control"
									selected={value}
									dateFormat="yyyy-MM-dd"
									onChange={(date) => onChange(date)}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col style={{ marginRight: '20px' }} className="  mbottom-20" xs={12} sm={4} md={4} lg={4} xl={4}>

					<Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
					>
						<FontAwesomeIcon type='submit' icon={faCheck} />
					</Button>
				</Col>
			</Row>
		</form>
	);
}

function FormularioMultipleP(props) {
	const { modal, nit } = props;
	const [nitId,setnetId]=useState()

	const [loading, setLoading] = useState(true);
	const [datosMultiples, setDatosMultiples] = useState([]);

	const agregarFormulario = () => {
		if (cambiar) {
			setDatosMultiples([...datosMultiples, {}]);
			cambiar=false
		} else {
			toast.error('Confirmar formulario actual para agregar mas ');
		}
	};
	useEffect(() => {
		setnetId(nit)
		nits=nit

	}, []);

	useEffect(() => {
		setTimeout(() => {
			setLoading(false)
		}, 1000);

	}, []);
	const confirmar = async () => {
		if (cambiar) {
			console.log('datos a enviar');
			console.log(dato);
			try {
				const resultado = await axios.post(`${URL_EMPLOYEE}/monthlyInstallment/create/lpr/createPlate`, dato)
				function reloadPage() {
					window.location.reload();
				}if (resultado.data['statusCode'] == 201) {
					for(const status of resultado.data.data){
					  const { statusCode, message } = status;
					  if(statusCode == 200){
						toast.success('Placa creado Exitosamente')
					  }else {
						dato = [];
						toast.error(message);
					  }
					}
					setInterval(reloadPage, 5000);
				  } else {
					console.log(resultado.data)
					toast.error(resultado.data.message)
					setInterval(reloadPage, 5000);
				  };
				
			} catch (error) {
				toast.error('Algo salio mal..');
			}
		} else {
			toast.error('Llenar o Verificar Formulario para Solicitar Desenchanche');
		}

	}

	return modal ? (
		loading ? (
			<div className="cargando">
				<div className="loader" id="loader">
					Loading...
				</div>
			</div>
		) : (
			<>

				<Formulario modal={modal}  />
				{datosMultiples.map((datos, index) => (
					<Formulario modal={modal} key={index} />
				))}
				<button style={{ margin: '10px' }} className=" btn btn-primary mtop-20 boton" onClick={agregarFormulario}><FontAwesomeIcon icon={faPlus} /></button>
				<Row className="justify-content-end mbottom-20">
					<Button style={{ marginRight: '20px' }} onClick={confirmar} variant="primary" className=" btn btn-primary mtop-20 boton"
					>
						Crear
					</Button>
				</Row>


			</>

		)) : (<></>)
}

export default FormularioMultipleP;
